// @ts-nocheck
import { tsValueToJsonValueFns, jsonValueToTsValueFns, } from "../../../../../../runtime/json/scalar";
import { default as serialize, } from "../../../../../../runtime/wire/serialize";
import { tsValueToWireValueFns, wireValueToTsValueFns, } from "../../../../../../runtime/wire/scalar";
import { default as deserialize, } from "../../../../../../runtime/wire/deserialize";
export function getDefaultValue() {
    return {
        selfLearningHierarchyId: "0",
    };
}
export function createValue(partialValue) {
    return {
        ...getDefaultValue(),
        ...partialValue,
    };
}
export function encodeJson(value) {
    const result = {};
    if (value.selfLearningHierarchyId !== undefined)
        result.selfLearningHierarchyId = tsValueToJsonValueFns.int64(value.selfLearningHierarchyId);
    return result;
}
export function decodeJson(value) {
    const result = getDefaultValue();
    if (value.selfLearningHierarchyId !== undefined)
        result.selfLearningHierarchyId = jsonValueToTsValueFns.int64(value.selfLearningHierarchyId);
    return result;
}
export function encodeBinary(value) {
    const result = [];
    if (value.selfLearningHierarchyId !== undefined) {
        const tsValue = value.selfLearningHierarchyId;
        result.push([1, tsValueToWireValueFns.int64(tsValue)]);
    }
    return serialize(result);
}
export function decodeBinary(binary) {
    const result = getDefaultValue();
    const wireMessage = deserialize(binary);
    const wireFields = new Map(wireMessage);
    field: {
        const wireValue = wireFields.get(1);
        if (wireValue === undefined)
            break field;
        const value = wireValueToTsValueFns.int64(wireValue);
        if (value === undefined)
            break field;
        result.selfLearningHierarchyId = value;
    }
    return result;
}
